export const getSchemaByType = <T>(graph: unknown[], type: string): T | undefined =>
    graph.find(
        (schema): schema is T =>
            typeof schema === "object" &&
            schema !== null &&
            (schema as Record<string, unknown>)["@type"] === type
    );